import { Product } from '@interfaces';
import {
  RootDiv,
  ProductQuantity,
  VerticalLine,
  ImgProduct,
  ImgDiv,
} from './Item.styles';
import { useState } from 'react';

import { extractExtraInfo } from '@screens/product/utils/extractExtraInfo';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';

import {
  DetailRootDiv,
  TitleTypography,
  DetailsTextTypography,
  DetailsPriceDiv,
  DetailsPriceTypographyBold,
  DetailsPriceTypographyLight,
} from './Item.styles';

const currFormat = new CurrencyFormatter({
  fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
});

interface ItemProps {
  product: Product;
  price: number;
  quantity: number;
}

export function Item({ product, price, quantity }: ItemProps) {
  const [imageUrl, setImageUrl] = useState(product.imagesUrl[0]);
  const handleImageError = () => {
    setImageUrl('/assets/images/default.webp');
  };

  return (
    <RootDiv>
      <ProductQuantity>{quantity}</ProductQuantity>
      <ImgDiv>
        <ImgProduct src={imageUrl} onError={handleImageError} />
      </ImgDiv>
      <VerticalLine />
      <DetailRootDiv>
        <TitleTypography variant="subtitle2">{product.name}</TitleTypography>
        <DetailsTextTypography>
          {extractExtraInfo(product)}
        </DetailsTextTypography>
        <DetailsTextTypography>{product.laboratory}</DetailsTextTypography>
        <DetailsPriceDiv>
          <DetailsPriceTypographyBold>
            {quantity > 1 && `${currFormat.format(price * quantity)}・`}
          </DetailsPriceTypographyBold>
          <DetailsPriceTypographyLight>
            {`${currFormat.format(price)}`}/un
          </DetailsPriceTypographyLight>
        </DetailsPriceDiv>
      </DetailRootDiv>
    </RootDiv>
  );
}
